import type { FetchMeQuery } from '@salescore/client-api'
import { notifyBugsnagFromErrorBoundary } from '@salescore/client-base'
import { ErrorContext } from '@salescore/client-common'
import { logger } from '@salescore/frontend-common'
import type { ReactElement } from 'react'
import * as React from 'react'

import { ErrorCard } from '../components/ErrorCard'

interface Properties {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any
  myUser?: Exclude<FetchMeQuery['myUser'], undefined | null>
  myIdentity?: FetchMeQuery['myUser']['identity']
}

export class ErrorProvider extends React.Component<Properties, { errors: Error[] }> {
  constructor(properties: Properties) {
    super(properties)
    this.state = { errors: [] }
  }

  override componentDidCatch(error: Error): void {
    notifyBugsnagFromErrorBoundary({
      error,
    })

    if (process.env.NODE_ENV === 'development') {
      throw error
    } else {
      this.setState({ errors: [error] })
    }
  }

  override render(): ReactElement {
    // Error handler

    const throwErrors = (errorOrErrors: Error | Error[]): void => {
      const errors: Error[] = Array.isArray(errorOrErrors) ? errorOrErrors : [errorOrErrors]

      const authorizationErrors = errors.filter(
        (x) => x.message.includes('Unauthorized: ') || x.message.includes('Forbidden: '),
      )
      if (authorizationErrors.length > 0) {
        // 現在のエラーと同じだったらセットしなおさない（無駄なレンダリングを防ぐ）
        if (JSON.stringify(this.state.errors) !== JSON.stringify(authorizationErrors)) {
          this.setState({ errors: authorizationErrors })
        }
      } else {
        for (const error of errors) {
          logger.debug(error)
        }
        if (JSON.stringify(this.state.errors) !== JSON.stringify(errors)) {
          this.setState({ errors })
        }
      }
    }

    const clearErrors = (): void => {
      this.setState({ errors: [] })
    }

    return (
      <ErrorContext.Provider value={{ throwErrors, clearErrors, myIdentity: this.props.myIdentity }}>
        {this.state.errors.length > 0 ? <ErrorCard errors={this.state.errors} /> : this.props.children}
      </ErrorContext.Provider>
    )
  }
}
